module.exports = __webpack_public_path__ + "static/media/reserveRoom.fe485410.svg";